var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 4C2.66665 3.63181 2.96515 3.33333 3.33331 3.33333H6.66665C7.03481 3.33333 7.33331 3.03486 7.33331 2.66667C7.33331 2.29847 7.03481 2 6.66665 2H3.33331C2.22874 2 1.33331 2.89543 1.33331 4V12C1.33331 13.1046 2.22874 14 3.33331 14H6.66665C7.03481 14 7.33331 13.7015 7.33331 13.3333C7.33331 12.9651 7.03481 12.6667 6.66665 12.6667H3.33331C2.96515 12.6667 2.66665 12.3682 2.66665 12V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8047 4.86193C11.5443 4.60158 11.1223 4.60158 10.8619 4.86193C10.6015 5.12227 10.6015 5.54439 10.8619 5.80474L12.3905 7.33333H5.99998C5.63182 7.33333 5.33331 7.63181 5.33331 8C5.33331 8.36819 5.63182 8.66667 5.99998 8.66667H12.3905L10.8619 10.1953C10.6015 10.4556 10.6015 10.8777 10.8619 11.1381C11.1223 11.3984 11.5443 11.3984 11.8047 11.1381L14.4714 8.47141C14.6015 8.34123 14.6666 8.17061 14.6666 8C14.6666 7.82939 14.6015 7.65877 14.4714 7.52859L11.8047 4.86193Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.e178b833b6653b530b169178801846c8.svg";
export { ForwardRef as ReactComponent };